export default __webpack_public_path__ + "static/media/tracks.6dd395d2.png";